import React from 'react';



export default class ConfirmModal extends React.PureComponent{
    static defaultProps = {
        type: 'info',
        "data-testid": 'confirm-modal'
    }

    buildHeader= () => {
        let {type} = this.props;
        if (type === 'warning') {
            return (
                <header className="modal-card-head has-background-danger-light justify-center">
                    <span className="icon has-text-danger "><i className="fas fa-exclamation-triangle fa-2x"/></span>
                </header>
            )
        }


        if (type === 'success') {
            return (
                <header className="modal-card-head has-background-success-light justify-center">
                    <span className="icon has-text-success is-size-1 "><i className="fas fa-check-circle fa-2x"/></span>
                </header>
            )
        }

        
            return (
                <header className="modal-card-head has-background-info-light justify-center">
                    <span className="icon has-text-info" ><i className="fas fa-info-circle fa-2x"/></span>
                </header>
            )
        
    }

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`} data-testid={this.props['data-testid']}>
                <div className="modal-background"/>
                <div className="modal-card">
                    {this.buildHeader()}
                    <section className="modal-card-body">
                        <h5 className="title is-5 mt-4 mb-6">{this.props.prompt}</h5>
                        {this.props.children}
                        <div className="buttons mt-5 is-justify-content-right">
                            <button
                                className={`button ${!(this.props.type === 'warning') && 'is-success'}`}
                                onClick={this.props.onAccept}
                            >{this.props.acceptButtonText || 'OK'}</button>
                            {this.props.onCancel &&
                                <button
                                    className="button is-danger"
                                    onClick={this.props.onCancel}
                                >{this.props.cancelButtonText || 'Cancel'}
                                </button>
                            }
                        </div>
                    </section>
                    {/* <footer className="modal-card-foot has-background-white"> */}

                    {/* </footer> */}
                </div>
            </div>
        )
    }

}
